import compose from '../../../utils/components/_compose';
import withUniqueId from '../../../hocs/helpers/_withUniqueId';

import DropList, { DropListProps } from './DropList';

export * from './DropList';

const ComposedDropList: (<Value, TargetProps = {}, OptionValue = Value>(
  props: DropListProps<Value, OptionValue> & TargetProps
) => React.ReactElement<DropListProps<Value, OptionValue> & TargetProps>) & {
  displayName: typeof DropList.displayName;
} = compose<any>(
  withUniqueId('dropListId'),
)(DropList);

ComposedDropList.displayName = 'DropList';

export default ComposedDropList;
